import type { JSX } from 'solid-js';

// The job and epic controls' 12px glyphs (#6753, prototype `ICON.pause12`, `ICON.play`,
// `ICON.stop`). Decorative: every button carries its own accessible name.

export type ControlGlyph = 'pause' | 'play' | 'stop';

const GLYPH: Readonly<Record<ControlGlyph, () => JSX.Element>> = {
  pause: () => (
    <g fill="currentColor">
      <rect x="4" y="3" width="2.6" height="10" rx="0.8" />
      <rect x="9.4" y="3" width="2.6" height="10" rx="0.8" />
    </g>
  ),
  play: () => (
    <path
      fill="currentColor"
      d="M5 3.2v9.6a.6.6 0 0 0 .9.5l7.6-4.8a.6.6 0 0 0 0-1L5.9 2.7a.6.6 0 0 0-.9.5z"
    />
  ),
  stop: () => <rect fill="currentColor" x="3.5" y="3.5" width="9" height="9" rx="1.5" />,
};

export function ControlIcon(props: { readonly glyph: ControlGlyph }): JSX.Element {
  return (
    <svg class="mission-ctl__icon" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true">
      {GLYPH[props.glyph]()}
    </svg>
  );
}
